<template>
    <div :contenteditable="!readOnly"
         class="c-input c-input--tiny"
         :class="{ 'invalid': invalid }"
         v-tooltip="{
            content: 'Maximum allowed is ' + max,
            show: invalid,
            classes: 'error',
            trigger: 'manual'
          }"
         @input="inputEditable($event.target.innerText)"
         @blur="inputBlur"
    >
    </div>
</template>

<script>
    export default {
        props: {
            content: [Object, Number, String],
            max: Number,
            readOnly: { type: Boolean, default: false }
        },
        data() {
          return {
              invalid: false
          }
        },
        mounted() {
            if (this.content) {
                this.$el.innerText = this.content;
            }
        },
        watch: {
            content() {
                this.$el.innerText = this.content;
            }
        },
        methods: {
            inputEditable(value) {
                if(String(value).length > this.max)
                {
                    this.invalid = true;
                    setTimeout(() => {
                        this.invalid = false;
                    }, 2000);
                    
                    this.$el.innerText = value.substring(0, this.max);
                }
            },
            inputBlur() {
                this.$emit('update:content', this.$el.innerText);
                this.$emit('change');
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";

    div[contenteditable] {
        min-height: 25px;
        max-width: 90%;
        &:focus {
            position: relative;
            z-index:1;
        }
    }
    .invalid {
        box-shadow: inset 0 0 0 3px $color-error !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/form/Editable.vue